import DateRangeOutlinedIcon from '@mui/icons-material/DateRangeOutlined';
import TimerOutlinedIcon from '@mui/icons-material/TimerOutlined';
import { Box } from '@mui/material';

import FileDownloadOutline from '@/assets/icons/FileDownloadOutline';
import Typography from '@/components/Typography';
import { useDataHubUserConfig } from '@/features/DataHub/hooks/useDataHubUserConfig';
import { getExportDateLabel, getExportSinceLabel } from '@/features/DataHub/utils/exportDetails';

const containerSx = {
  display: 'grid',
  gridTemplateColumns: 'repeat(3, 1fr)',
  gap: 2,
  justifyContent: 'space-between',
  borderBottomWidth: 1,
  borderColor: 'rgba(248, 248, 248, 0.20)',
  borderBottomStyle: 'solid',
  pb: 2,
  px: 2,
  mt: 1
};

const startItemSx = { display: 'flex', alignItems: 'center', gap: 0.5 };
const centerItemSx = { display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5 };
const endItemSx = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: 0.5,
  textAlign: 'right' as const
};

export const ExportDetails = ({
  settings,
  exportTimestamp,
  name,
  hideNoMetadataLabel = false
}: {
  name?: string;
  exportTimestamp?: number;
  hideNoMetadataLabel?: boolean;
  settings: {
    date: {
      from: Date | string | null;
      to: Date | string | null;
    };
    timezone: string;
    includeMetadata: boolean;
  };
}) => {
  const { dateFormatValue } = useDataHubUserConfig();

  const date = getExportDateLabel({
    settings: settings.date,
    timezone: settings.timezone,
    dateFormat: dateFormatValue,
    exportTimestamp
  });

  const since = getExportSinceLabel(exportTimestamp);
  let metadataLabel = '';

  if (settings.includeMetadata) {
    metadataLabel = ' - Metadata included';
  } else if (!hideNoMetadataLabel) {
    metadataLabel = ' - No metadata';
  }

  return (
    <Box sx={containerSx}>
      <Typography
        size={14}
        sx={startItemSx}
      >
        <FileDownloadOutline sx={{ fontSize: 'inherit' }} />
        {name}
        {name && metadataLabel}
      </Typography>

      <Typography
        size={14}
        sx={centerItemSx}
      >
        <DateRangeOutlinedIcon sx={{ fontSize: 'inherit' }} />
        {date}
      </Typography>

      <Typography
        size={14}
        sx={endItemSx}
      >
        <TimerOutlinedIcon sx={{ fontSize: 'inherit' }} />
        {since}
      </Typography>
    </Box>
  );
};
